export default __webpack_public_path__ + "static/media/developmentIcon.a350bc71.svg";